module.exports = __webpack_public_path__ + "prod/1.42.2/img/bankeys-downloadBg.899f0d57.png";